import { combineEpics } from "redux-observable";
import { epicBuyWithGoldBeginProcess } from "./epicBuyWithGoldBeginProcess";
import { epicBuyWithGoldCheckConfirmationNeeded } from "./epicBuyWithGoldCheckConfirmationNeeded";
export var epicBuyWithGold = combineEpics(epicBuyWithGoldBeginProcess, epicBuyWithGoldCheckConfirmationNeeded);



//////////////////
// WEBPACK FOOTER
// ./src/features/buy-with-gold/epicBuyWithGold.ts
// module id = 1787
// module chunks = 3